// services/dashboardService.js
import axios from "axios";
import API_URL from "../config/config";

// Fetch user name by ID
export const getUserName = async (user_id) => {
  try {
    const response = await axios.get(
      `${API_URL}/user/getUserNameById/${user_id}`,
    );
    console.log("response", response);
    return response.data.name;
  } catch (error) {
    console.error("Error fetching user name:", error);
    throw error;
  }
};

// Check if the quiz has started for the user
export const checkQuizStatus = async (user_id) => {
  try {
    const response = await axios.get(
      `${API_URL}/dashboard/checkquiz/${user_id}`,
    );
    return response.data.message === "Assessment found!";
  } catch (error) {
    console.error("Error fetching quiz status:", error);
    throw error;
  }
};

// Get recommended learning paths for the user
export const getRecommendedPaths = async ({ user_id, assessment_id }) => {
  console.log("called assessment id", assessment_id);
  const url = assessment_id
    ? `${API_URL}/dashboard/getCoursesByUser/${user_id}/${assessment_id}`
    : `${API_URL}/dashboard/getCoursesByUser/${user_id}`;
  try {
    const response = await axios.get(url);
    return response.data.courses;
  } catch (error) {
    console.error("Error fetching recommended paths:", error);
    throw error;
  }
};

// Submit a request for a dedicated learning path
export const submitDedicatedLearningRequest = async (user_id, formData) => {
  try {
    await axios.post(`${API_URL}/dashboard/request-dedicated-learning`, {
      ...formData,
      user_id,
    });
  } catch (error) {
    console.error("Error submitting the form:", error);
    throw error;
  }
};
